import React from 'react';
import styled from 'styled-components';

import IconButton from '@mui/material/IconButton';
import Save from '@mui/icons-material/AssignmentTurnedIn';
import Cancel from '@mui/icons-material/Clear';
import Reset from '@mui/icons-material/Replay';

const FieldButtonToolbar = ({
  onReset,
  onSave,
  onCancel,
  disabled
}) => {
  const buttonIconStyle = {
    height: '18px',
    width: '18px'
  }

  return (
    <ButtonWrapper>
      {
        onReset &&
        <IconButton
          size='small'
          onClick={onReset}
          disabled={disabled}
          style={{ marginLeft: '4px' }}
          title='Reset to default'
        >
          <Reset style={buttonIconStyle}/>
        </IconButton>
      }
      {
        onCancel &&
        <IconButton
          size='small'
          onClick={onCancel}
          disabled={disabled}
          style={{ marginLeft: '4px' }}
          title='Cancel'
        >
          <Cancel style={buttonIconStyle}/>
        </IconButton>
      }
      {
        onSave &&
        <IconButton
          size='small'
          onClick={onSave}
          disabled={disabled}
          style={{ marginLeft: '4px' }}
          color='secondary'
          title='Save'
        >
          <Save style={buttonIconStyle} color='secondary'/>
        </IconButton>
      }
    </ButtonWrapper>
  )
}

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export { FieldButtonToolbar };
